
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import { APP_CONFIG } from '@/config/app-config';
import { DATA } from '@/config/data';
import AmountDetail from './components/AmountDetail.vue';
import BillOfLading from './components/BillOfLading.vue';
import { ExportReceiptModel } from '@/models/export-receipt';
import { BillOfLadingModel } from '@/models/bill-of-lading';
import formatNumber from '@/shared/filters/format-number';
import exportReceiptServices from '@/services/export-receipt-services';

@Component({
    components: {
        Loading,
        'amount-detail': AmountDetail,
        'bill-of-lading': BillOfLading
    }
})
export default class DetailPaymentRequest extends Vue {
    private exportReceipt: ExportReceiptModel = new ExportReceiptModel();
    private listPackages: BillOfLadingModel[] = [];
    private isLoading = false;

    get receiptId() {
        return Number(this.$route.params.id);
    }

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    @Watch('receiptId', { immediate: true, deep: true })
    private async watchOrderId() {
        if (this.receiptId) {
            this.loadData();
        }
    }

    private getStatus(value: any) {
        return DATA.billOfLadingStatus.find(x => x.value === value) || { value: 0, name: 'N/A', color: '#49494a' };
    }

    private async loadData() {
        if (this.receiptId) {
            const result = await exportReceiptServices.getDetail(this.receiptId);
            this.listPackages = [];
            if (result && result.status === 200 && (result.data.data.length > 0 || result.data.data.ID > 0)) {
                const ret = result.data.data;
                this.exportReceipt = new ExportReceiptModel();
                this.exportReceipt.ID = ret.ID;
                this.exportReceipt.UID = ret.UID;
                this.exportReceipt.Username = ret.Username;
                this.exportReceipt.Status = ret.Status;
                this.exportReceipt.StatusDetail = DATA.receiptStatus.find(x => x.value === ret.Status) || { value: 0, name: 'Khác', color: '#3b4354' };
                this.exportReceipt.ExchangeRate = ret.ExchangeRate;
                this.exportReceipt.Weight = ret.Weight;
                this.exportReceipt.Volume = ret.Volume;
                this.exportReceipt.NumberOfPack = ret.NumberOfPack;
                this.exportReceipt.FeeShip = ret.FeeShip;
                this.exportReceipt.FeeShipVND = ret.FeeShipVND;
                this.exportReceipt.FeeType = ret.FeeType;
                this.exportReceipt.Price = ret.Price;
                this.exportReceipt.Amount = ret.Amount;
                this.exportReceipt.PaymentMethod = ret.PaymentMethod;
                this.exportReceipt.PaymentDate = ret.PaymentDate;
                this.exportReceipt.ExportDate = ret.ExportDate;
                this.exportReceipt.CreatedDate = ret.CreatedDate;
                const tmpListOrder: BillOfLadingModel[] = [];
                for (const item of ret.Packages) {
                    const order = new BillOfLadingModel();
                    order.id = item.ID;
                    order.status = item.Status;
                    order.statusDetail = this.getStatus(item.Status);
                    order.orderTransactionCode = item.OrderTransactionCode;
                    order.weight = item.Weight > 0 ? `${formatNumber(item.Weight, '0,0.[0000]')} kg` : '';
                    order.volume = item.Volume > 0 ? `${formatNumber(item.Volume, '0,0.[0000]')} m3` : '';
                    tmpListOrder.push(order);
                }
                this.listPackages = tmpListOrder;
            }
        }
    }
}
